import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { desktopExpandedFacets } from '../config'
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default ({ facet }) => {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [ activeRange, setActiveRange ] = useState(null);
    const [ active, setActive ] = useState(isSelected);
    
    useEffect(() => {
        if(window.innerWidth > 999 && desktopExpandedFacets.includes(facet.name)) {
            setActive(true)
        }
    }, [])

    useEffect(() => {
        if(isSelected) {
            setActiveRange(`$ ${range[0]} - $ ${range[1]}`);
        } else {
            setActiveRange(null);
        }
    }, [isSelected, range])

    return (
        <div class={`product-facet__filter-item ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
            <button class="collapsible-toggle text--strong"
                onClick={() => { setActive(!active) }}
            >
                {facet.name}
                {activeRange && <span class="collapsible-toggle__selected-value text--subdued text--small hidden-tablet-and-up">{activeRange}</span>}
                <svg focusable="false" width="12" height="8" class="icon icon--chevron icon--inline  " viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.2"></path></svg>
            </button>
            <div class="ns-sidebar-submenu">
                <div class="ns-facet-value-container">
                    <RangeSlider id={facet.id} />
                    <div class="price-range__input-group">
                        <div class="price-range__input input-prefix text--xsmall">
                            {facet.name === 'Price' && <span class="input-prefix__value text--subdued">$</span>}
                            <input
                                type="number"
                                class="input-prefix__field"
                                id={`ns-${facet.id}-min`}
                                value={range[0]}
                                min={min}
                                max={max}
                                onChange={(e) => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <span class="price-range__delimiter text--small">to</span>
                        <div class="price-range__input input-prefix text--xsmall">
                            {facet.name === 'Price' && <span class="input-prefix__value text--subdued">$</span>}
                            <input
                                type="number"
                                class="input-prefix__field"
                                id={`ns-${facet.id}-max`}
                                value={range[1]}
                                min={min}
                                max={max}
                                onChange={(e) => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
